import { Component, OnDestroy, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FormValidatorService } from '../../../../shared/services/form-validator.service';
import { TranslateService } from '@ngx-translate/core';
import { Validators } from '../../../../shared/validators';
import { ResetPasswordCodeinquiryService } from '../../services/reset-password-codeinquiry.service';
import { ResetPasswordService } from '../../services/reset-password.service';
import { Location } from '@angular/common';
import { LanguageService } from '../../../../shared/services/language.service';
import { CustomValidators } from 'src/app/shared/custom-validators';
import { ReCaptchaService } from 'angular-recaptcha3';
import Swal from "sweetalert2";

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  resetForm: FormGroup;
  formValidator: FormValidatorService = new FormValidatorService();
  token: string;

  passwordNotMatching = false;

  errorResponse = false;

  constructor(
    private route: ActivatedRoute,
    private resetPasswordCodeinquiryService: ResetPasswordCodeinquiryService,
    private resetPasswordService: ResetPasswordService,
    private router: Router,
    private location: Location,
    private translate: TranslateService,
    private languageService: LanguageService,
    private recaptchaService: ReCaptchaService,
    @Inject(PLATFORM_ID) private platformID
  ) {}

  async ngOnInit() {
    if (isPlatformBrowser(this.platformID)) {
      if (localStorage.getItem('language')) {
        this.translate.use(localStorage.getItem('language'));
      }
      this.languageService.languageUpdated.subscribe((lang) => {
        this.translate.use(lang);
      });
      this.token = this.route.snapshot.params.token;

      try {
        this.resetPasswordCodeinquiryService.setParams({ token: this.token });
        const resetPasswordCodeinquiryResponse =
          await this.resetPasswordCodeinquiryService.make();
        localStorage.setItem(
          'uID',
          JSON.stringify(resetPasswordCodeinquiryResponse['userId'])
        );
      } catch (e) {
        this.router.navigateByUrl('/');
      }

      this.resetForm = this.formValidator.createForm([
        {
          fieldName: 'password',
          defaultValue: null,
          validators: [
            {
              validatorFn: Validators.required,
              message: '',
            },
            {
              validatorFn: Validators.minLength(6),
              message: '',
            },
            {
              validatorFn: CustomValidators.complexPassword('s'),
              message: ""
            },
          ],
        },
        {
          fieldName: 'confirmPassword',
          defaultValue: null,
          validators: [
            {
              validatorFn: Validators.required,
              message: '',
            },
            {
              validatorFn: Validators.minLength(8),
              message: '',
            },
          ],
        },
      ]);
      this.translateValidationMessages();
      this.translate.onLangChange.subscribe(() => {
        this.translateValidationMessages();
      });
    }
  }

  translateValidationMessages() {
    this.translate.get('FormValidation').subscribe(() => {
      this.formValidator.validationMessages = {
        password: {
          required: this.translate.instant("FormValidation.Empty", {
            field: "Password",
            fieldAr: "كلمة المرور"
          }),
          minLength: this.translate.instant("FormValidation.MinLength", {
            field: "password",
            fieldAr: "كلمة المرور",
            value: 8
          }),
          complexPassword:this.translate.instant("FormValidation.complexPassword", {
            field: "password",
            fieldAr: "كلمة المرور",
          }),
        },
        confirmPassword: {
          required: this.translate.instant("FormValidation.Empty", {
            field: "Confirm password",
            fieldAr: "تأكيد كلمة المرور"
          }),
          minLength: this.translate.instant("FormValidation.MinLength", {
            field: "Confirm password",
            fieldAr: "تأكيد كلمة المرور",
            value: 8
          }),

        }
      }
    });
  }

  ngOnDestroy() {
    if (isPlatformBrowser(this.platformID)) {
      localStorage.removeItem('uID');
    }
  }

  async onSubmit() {
    if (this.resetForm.invalid) {
      this.formValidator.forceShowErrors();
      this.passwordNotMatching = false;
      return;
    }
    const recaptchaToken = await this.recaptchaService.execute({
      action: 'resetPassword',
    });
    const toService = {
      newPass: this.resetForm.value.password,
      token: this.token,
      recaptchaToken,
    };
    try {
      this.resetPasswordService.setParams(toService);
      await this.resetPasswordService.make();
      this.router.navigateByUrl('/login');
    } catch (e) {
      this.errorResponse = true;
      this.resetForm.reset();

      if(e?.faultyRequest?.error?.name === "PasswordHistoryException"){
        await Swal.fire({
          icon: 'error',
          text: this.translate.instant('Verification.PasswordMustBeNew'),
          confirmButtonText: this.translate.instant('Sellers.Products.Confirm'),
        });
      }
    }
  }

  onCancel() {
    this.location.back();
  }

  matchPassword() {
    if (
      this.resetForm.value.confirmPassword &&
      this.resetForm.value.password !== this.resetForm.value.confirmPassword
    ) {
      this.passwordNotMatching = true;
    } else {
      this.passwordNotMatching = false;
    }
  }
}
